// Brief item titles can be stored with HTML-encoded characters (e.g. `&amp;`).
export default function decodeHtmlEntities(str: string): string {
  const el = document.createElement('textarea');
  el.innerHTML = str;
  return el.value;
}
